import * as React from 'react';
export const DragAndDropContext = React.createContext({
    availableItems: [],
    permittedActions: {
        createTab: true,
        editTabName: true,
        dragAndDropTab: true,
        deleteTab: true,
    },
});
